import { gsap } from 'gsap';
import scrollLock, { addFillGapTarget } from 'scroll-lock';
import { getMenu } from '../../components/Menu';

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise(async (resolve) => {
			const menu = getMenu();
			const nav = current.container.querySelector('[data-nav]');
			addFillGapTarget(nav);
			scrollLock.disablePageScroll();
			await menu.close();
			
			gsap.to(current.container, {
				opacity: 0,
				ease: "power1.out",
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	afterLeave({ current, next, trigger }) {

		window.scrollTo(0, 0);

		gsap.set(next.container, {
			opacity: 0,
		});

		current.container.classList.add('default-transition-absolute');

		gsap.set(current.container, {
			position: 'absolute',
			top: 0,
			left: 0,
			width: current.container.getBoundingClientRect().width,
			zIndex: -1,
		});

	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(next.container, {
				opacity: 1,
				ease: "power1.in",
				duration: 0.3,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	afterEnter({ current, next, trigger }) {
		scrollLock.clearQueueScrollLocks();
		scrollLock.enablePageScroll();
	}
};
